import { lazy } from "react";

const SystemSuperCategoriesPage = lazy(
  () => import("@/widgets/catalog/system/super-categories/SuperCategoriesPage"),
);
const SystemSuperCategoryAddPage = lazy(
  () =>
    import(
      "@/widgets/catalog/system/super-categories/SystemSuperCategoryAddPage"
    ),
);
const SystemSuperCategoryEditPage = lazy(
  () =>
    import(
      "@/widgets/catalog/system/super-categories/SystemSuperCategoryEditPage"
    ),
);
const SystemSuperCategoryDetailPage = lazy(
  () =>
    import(
      "@/widgets/catalog/system/super-categories/SystemSuperCategoryDetailPage"
    ),
);

const SystemSuperCategoryRoutes = {
  path: "super-categories",
  children: [
    { index: true, element: <SystemSuperCategoriesPage /> },
    {
      path: "add-new-super-category",
      element: <SystemSuperCategoryAddPage />,
    },
    {
      path: ":superCategoryId",
      children: [
        { index: true, element: <SystemSuperCategoryDetailPage /> },
        { path: "edit", element: <SystemSuperCategoryEditPage /> },
      ],
    },
  ],
};

export default SystemSuperCategoryRoutes;
